import { SVGAttributes } from "preact";

export default function OpenIcon(props: SVGAttributes<SVGSVGElement>) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" className="openSvg" aria-hidden="true" role="img" preserveAspectRatio="xMidYMid meet" viewBox="0 0 256 256" {...props}>
          <path fill="currentColor" d="M132 24A100.11 100.11 0 0 0 32 124v84a16 16 0 0 0 16 16h84a100 100 0 0 0 0-200m32 128H96a8 8 0 0 1 0-16h68a8 8 0 0 1 0 16m0-32H96a8 8 0 0 1 0-16h68a8 8 0 0 1 0 16"></path>
        </svg>
    )
}
